// extracted by mini-css-extract-plugin
module.exports =  {"search-bar-container":"search-bar-container-sTkGP","search-input":"search-input-Q18HV","icon":"icon-M3jX0"};